import createAction from 'redux-actions/es/createAction';

export const getCountriesAction = createAction('GET_COUNTRIES_ACTION');

export const getCountriesRequest = createAction('GET_COUNTRIES_REQUEST');
export const getCountriesSuccess = createAction('GET_COUNTRIES_SUCCESS');
export const getCountriesFail = createAction('GET_COUNTRIES_FAIL');
